/* Ape the Label behaviour tracking (1 Oct 2026). Loaded by sections/ape-analytics.liquid.
   Records clicks, rage and dead clicks, scroll depth and active time, batched and sent with
   sendBeacon so nothing blocks the page. Commerce events come from the Shopify custom pixel.
   Both share the _ape_v (visitor) and _ape_s (session) cookies. Add ?ape_ignore=1 to any URL
   once to exclude your own browser; ?ape_heatmap=30 draws the click map on the live page. */
(function () {
  var C = window.apeTrackConfig;
  if (!C || !C.endpoint) return;
  var END = C.endpoint.replace(/\/$/, '');
  var qs = location.search;
  if (qs.indexOf('ape_heatmap=') > -1) { var o = document.createElement('script'); o.src = END + '/overlay.js'; o.async = true; document.head.appendChild(o); return; }
  if (qs.indexOf('ape_ignore=1') > -1) document.cookie = '_ape_x=1; path=/; max-age=15552000; SameSite=Lax; Secure';
  if (/(^|; )_ape_x=1/.test(document.cookie)) return;
  if (navigator.webdriver || window.top !== window || (window.Shopify && Shopify.designMode)) return;

  function allowed() {
    try { var p = window.Shopify && Shopify.customerPrivacy; if (p && typeof p.analyticsProcessingAllowed === 'function') return p.analyticsProcessingAllowed() !== false; } catch (e) {}
    return true;
  }
  function uid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 10); }
  function getCookie(n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; }
  function setCookie(n, v, age) { document.cookie = n + '=' + encodeURIComponent(v) + '; path=/; max-age=' + age + '; SameSite=Lax; Secure'; }

  // Ids are shared with the pixel through the cookies. On a first page neither script finds one, so each writes a
  // candidate, waits a moment and adopts whatever the cookie holds by then: both end up with the same id.
  var SESSION_MS = 1800000, vid, sid;
  function resolve() {
    var settle = false, v = getCookie('_ape_v'), s = getCookie('_ape_s').split('.'), last = +s[1] || 0;
    if (!v) { v = uid(); setCookie('_ape_v', v, 34560000); settle = true; }
    var id = s[0];
    if (!id || Date.now() - last > SESSION_MS) { id = uid(); settle = true; }
    vid = v; sid = id; touch();
    if (settle) setTimeout(function () { vid = getCookie('_ape_v') || vid; sid = getCookie('_ape_s').split('.')[0] || sid; }, 900);
  }
  function touch() { setCookie('_ape_s', sid + '.' + Date.now(), 86400); }
  resolve();

  var sampled = sessionStorage.getItem('_ape_smp');
  if (sampled === null) { sampled = Math.random() < (C.sample || 1) ? '1' : '0'; try { sessionStorage.setItem('_ape_smp', sampled); } catch (e) {} }
  if (sampled !== '1') return;

  var dev = innerWidth < 750 ? 'mobile' : innerWidth < 1024 ? 'tablet' : 'desktop';
  var queue = [], timer = 0;
  function push(e) {
    if (!allowed()) return;
    e.t = Date.now(); e.path = location.pathname; e.dev = dev; e.vw = innerWidth; e.vh = innerHeight;
    if (!e.ph) e.ph = document.documentElement.scrollHeight;
    queue.push(e);
    if (queue.length >= 20) flush(); else if (!timer) timer = setTimeout(flush, 4000);
  }
  function flush() {
    clearTimeout(timer); timer = 0;
    if (!queue.length) return;
    // the session may have been rotated by the pixel, or gone idle for 30 minutes: follow the cookie, then stamp the batch
    var s = getCookie('_ape_s').split('.');
    if (s[0] && Date.now() - (+s[1] || 0) <= SESSION_MS) sid = s[0]; else if (s[0]) sid = uid(); // no cookie at all (blocked): keep the one we have
    touch();
    var batch = queue.splice(0, 50);
    for (var i = 0; i < batch.length; i++) { batch[i].vid = vid; batch[i].sid = sid; }
    var body = JSON.stringify({ v: 1, e: batch });
    if (!(navigator.sendBeacon && navigator.sendBeacon(END + '/c', body))) {
      try { fetch(END + '/c', { method: 'POST', body: body, keepalive: true, headers: { 'Content-Type': 'text/plain' } }); } catch (e) {}
    }
    if (queue.length) flush();
  }

  // Clicks: the nearest interactive element is what gets recorded; anything else is a dead click.
  function selector(el) {
    var parts = [], node = el, depth = 0;
    while (node && node.nodeType === 1 && node !== document.body && depth < 6) {
      var id = node.id;
      if (id && id.indexOf('shopify-section') === 0) break;
      if (id && !/\d{4,}/.test(id)) { parts.unshift('#' + CSS.escape(id)); break; }
      var part = node.tagName.toLowerCase();
      var cls = (typeof node.className === 'string' ? node.className : '').split(/\s+/).filter(function (c) {
        return c && !/\d|hover|active|focus|open|visible|is-|js-|aos|loaded|selected|current/.test(c);
      })[0];
      if (cls) part += '.' + CSS.escape(cls);
      else if (node.parentElement) {
        var sib = Array.prototype.filter.call(node.parentElement.children, function (x) { return x.tagName === node.tagName; });
        if (sib.length > 1) part += ':nth-of-type(' + (sib.indexOf(node) + 1) + ')';
      }
      parts.unshift(part); node = node.parentElement; depth++;
    }
    return parts.join(' > ');
  }
  var clicks = [];
  document.addEventListener('click', function (ev) {
    var el = ev.target; if (!el || el.nodeType !== 1) return;
    var act = el.closest('a,button,[role="button"],input,select,textarea,label,summary,[data-collapsible-trigger],[data-quick-add]');
    var target = act || el;
    var r = target.getBoundingClientRect();
    var sec = el.closest('[id^="shopify-section-"]');
    var raw = target.getAttribute('aria-label') || target.alt || (target.innerText || '').trim();
    var txt = (act || (target.children.length < 4 && raw.length < 300) ? raw : '').replace(/\s+/g, ' ').slice(0, 60);
    push({ ev: 'click', sel: selector(target), txt: txt, sec: sec ? sec.id.replace('shopify-section-', '').slice(0, 80) : '',
      x: +(100 * ev.pageX / document.documentElement.scrollWidth).toFixed(2), y: Math.round(ev.pageY),
      ex: r.width ? +((ev.clientX - r.left) / r.width).toFixed(3) : 0.5, ey: r.height ? +((ev.clientY - r.top) / r.height).toFixed(3) : 0.5,
      n: act ? 1 : 0 });
    var now = Date.now();
    clicks = clicks.filter(function (c) { return now - c.t < 700 && Math.abs(c.x - ev.clientX) < 30 && Math.abs(c.y - ev.clientY) < 30; });
    clicks.push({ t: now, x: ev.clientX, y: ev.clientY });
    if (clicks.length === 3) push({ ev: 'rage', sel: selector(target), txt: txt, n: 3 });
  }, { capture: true, passive: true });

  // Scroll depth milestones, once each per page view.
  var marks = { 25: 0, 50: 0, 75: 0, 100: 0 }, ticking = false;
  function depth() {
    ticking = false;
    var h = document.documentElement.scrollHeight || 1;
    var d = Math.min(100, Math.round((scrollY + innerHeight) / h * 100));
    for (var m in marks) if (!marks[m] && d >= m) { marks[m] = 1; push({ ev: 'scroll', n: +m, ph: h }); }
  }
  addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(depth); } }, { passive: true });
  setTimeout(depth, 1500);

  // Active time: seconds the page was in the foreground while the visitor had done something (scroll, tap, key, mouse)
  // in the last five minutes. Sent every 30 seconds of it, and whatever is left when the page goes away, so a tab left
  // open overnight counts nothing and a visitor reading for ten minutes still shows as on the site.
  var lastInput = Date.now(), acc = 0;
  ['pointerdown', 'keydown', 'scroll', 'touchstart', 'mousemove', 'wheel'].forEach(function (n) { addEventListener(n, function () { lastInput = Date.now(); }, { capture: true, passive: true }); });
  setInterval(function () {
    if (document.visibilityState !== 'visible' || Date.now() - lastInput > 300000) return;
    acc += 5;
    if (acc >= 30) { push({ ev: 'engaged', n: acc }); acc = 0; }
  }, 5000);
  function leave() { if (acc >= 1) { push({ ev: 'engaged', n: acc }); acc = 0; } flush(); }
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') leave(); });
  addEventListener('pagehide', leave);
})();
